import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Button } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppSelector } from '../../../../hooks.js';
import { isLoadingSelector } from '../../passwordlessSlice.js';
export const ResendEmailButton = ({ onClick }) => {
    const { t } = useTranslation();
    const isLoading = useAppSelector(isLoadingSelector);
    return (_jsx(Button, { "data-testid": "passwordless-resend-email-button", autoFocus // it is used to focus on the button first instead of the input fields
        : true, variant: "secondary", a11yLabel: "resend email", type: "submit", onClick: onClick, isFullWidth: true, isLoading: isLoading, marginTop: 'spaceS', size: ['medium'], children: t('loginregistration.passwordless.invalidLink.resendEmailButton') }));
};
//# sourceMappingURL=ResendEmailButton.js.map